import * as THREE from "three";
import {LineCurved} from "../../Shapes/LineCurved";
import {Line} from "../../Shapes/Line";
import {ManagerRouter} from "./ManagerRouter";
import {NetworkManager} from "../Server/ManagerGeneralServer";
import {RouterNetworkTree} from "../../../../../../../services/back/infrastructure-schema.service";
import {RouterNodeOutput} from "../../System/GlobalSizing";

export function RoutersManager(
	scene: THREE.Scene,
	x:number,
	z:number,
	data: Array<RouterNetworkTree>,
	dataguide: RouterNodeOutput[]
): void {

	const radius: number = 1;

	switch (data.length) {
		case 0:
			break
		case 1:
			Line(scene, x, z, x, z + 2);
			ManagerGeneral(scene, x, z, data, dataguide)
			break
		case 2:
			Line(scene, x, z, x, z + 2);
			LineCurved(scene, x, z, radius, "SE");
			ManagerGeneral(scene, x, z, data, dataguide)
			break
		default:
			Line(scene, x, z, x, z + 2);
			LineCurved(scene, x, z, radius, "SW");
			LineCurved(scene, x, z, radius, "SE");
			ManagerGeneral(scene, x, z, data, dataguide)
			break;
	}
}

function ManagerGeneral(
	scene: THREE.Scene,
	x: number,
	z: number,
	data: Array<RouterNetworkTree>,
	dataguide: RouterNodeOutput[]
): void {

	ManagerRouter(scene, x, z, data[0].router.type, data[0].router.name, data[0].router.id)
	NetworkManager(scene, x, z + 5, data[0].connectedNetworks, 0, dataguide)

	if ((data.length - 1) % 2 === 0 ) {
		ManagerRouterRight(scene, x, z, data, dataguide, 1)
		ManagerRouterLeft(scene, x, z, data, dataguide, (data.length/2)+.5)
	} else {
		ManagerRouterRight(scene, x, z, data, dataguide, 1)
		ManagerRouterLeft(scene, x, z, data, dataguide, (data.length/2))
	}
}

function ManagerRouterRight(
	scene: THREE.Scene,
	x: number,
	z: number,
	data: Array<RouterNetworkTree>,
	dataguide: RouterNodeOutput[],
	i: number,
): void {

	if (i<=(data.length-1)/2) { // avant i<(data.length-1)/2

		const backOffset: number = dataguide[i-1].rightSize
		const frontOffset: number = -dataguide[i].leftSize //- 2

		Line(scene, x + 1, z + 1, x + backOffset + frontOffset - 1, z + 1)
		LineCurved(scene, x+backOffset+frontOffset - 1, z + 1, 1, "WS")
		if (i>1) {
			Line(scene, x - 1, z + 1, x+1, z + 1)
		}

		ManagerRouter(scene, x + backOffset + frontOffset, z, data[i].router.type, data[i].router.name, data[i].router.id)
		NetworkManager(scene, x + backOffset + frontOffset, z + 5, data[i].connectedNetworks, i, dataguide)
		// Récursivité
		ManagerRouterRight(scene, x + backOffset + frontOffset, z, data, dataguide, i+1)
	}
}

function ManagerRouterLeft(
	scene: THREE.Scene,
	x: number,
	z: number,
	data: Array<RouterNetworkTree>,
	dataguide: RouterNodeOutput[],
	i: number,
): void {

	if (i < data.length) {

		let backOffset: number;

		// Calcule du nombre d'écarts avec les routers suivant
		if (i==(data.length/2)+.5 || i==(data.length/2)) {
			backOffset = -dataguide[0].leftSize
		} else {
			backOffset = -dataguide[i-1].leftSize
		}
		const frontOffset: number = dataguide[i].rightSize //- 2

		Line(scene, x-1, z+1, x - backOffset - frontOffset + 1, z+1)
		LineCurved(scene, x - backOffset - frontOffset + 1, z + 1, 1, "ES")
		if (i > (data.length/2)+.5) {
			Line(scene, x + 1, z + 1, x-1, z + 1)
		}

		ManagerRouter(scene, x - backOffset - frontOffset, z, data[i].router.type, data[i].router.name, data[i].router.id)
		NetworkManager(scene, x - backOffset - frontOffset, z + 5, data[i].connectedNetworks, i, dataguide)
		ManagerRouterLeft(scene, x - backOffset - frontOffset, z, data, dataguide, i+1)
	}
}
